// extracted by mini-css-extract-plugin
export default {"controlButton":"Na3n_B","hidden":"pQGslN","title":"kjV_k2","link":"KDTrJq"};